/* Supply › Reports › Sales Reports — hub of sales sub-reports. */
import React from "react";
import { ReportHub } from "./reportShared";
import { PHARMACY_ROUTES } from "../../../Route/path";

const CARDS = [
  {
    title: "Sale Report (Datewise)",
    desc: "Item-level sale lines billed in a date window — batch, tax and margin, with CSV download.",
    path: PHARMACY_ROUTES.SALES_REPORT_DATEWISE,
  },
  {
    title: "Sales Register",
    desc: "Detailed view of all sales invoices by channel, date, and payment status.",
    path: PHARMACY_ROUTES.SALES_REPORT_REGISTER,
  },
  {
    title: "Sales by Channel",
    desc: "Sales totals grouped by channel (B2C / CHE / Eyewear) over a date range.",
    path: PHARMACY_ROUTES.SALES_REPORT_CHANNEL,
  },
  {
    title: "Outstanding Payments",
    desc: "Invoices with a balance still due, ranked by amount outstanding.",
    path: PHARMACY_ROUTES.SALES_REPORT_OUTSTANDING,
  },
];

const SalesReport = () => (
  <ReportHub title="Sales Reports" sub="Sales registers, channel splits, and receivables" cards={CARDS} />
);

export default SalesReport;
